export default "__VITE_ASSET__DmGyHZ_0__"